<template>
  <div>
    <Photo :me="me" :photo="photo" :sorround="sorround" :go-back="goBack" />
    <Actions
      :me="me"
      :photo="photo"
      :info="info"
      :categories="categories"
      :go-back="goBack"
    />
    <Details :me="me" :photo="photo" :info="info" />
    <Stats :me="me" :photo="photo" />
    <Curate :me="me" :photo="photo" :info="info" />
    <Featured-galleries
      v-if="
        featuredIn.length > 0 &&
          photo.statusName !== types.photo.status.inCuration
      "
      :photo="photo"
      :galleries="featuredIn"
    />
    <Comments
      :me="me"
      :photo="photo"
      :comments="comments"
      :is-last-page="isLastPage"
      :page="page"
      :loading="loading"
    />
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex'
import { mapState } from 'vuex'
import Photo from '@/components/photo/Photo.vue'
import Actions from '@/components/photo/Actions.vue'
import Details from '@/components/photo/Details.vue'
import Stats from '@/components/photo/Stats.vue'
import Curate from '@/components/photo/Curate.vue'
import FeaturedGalleries from '@/components/photo/FeaturedGalleries.vue'
import Comments from '@/components/photo/Comments.vue'
import types from '@/utils/types'
import { EventBus } from '@/plugins/event-bus'

export default {
  components: {
    Photo,
    Actions,
    Details,
    Stats,
    Curate,
    FeaturedGalleries,
    Comments
  },
  middleware: 'header',
  transition: 'photo',
  async asyncData({ params, query, store, $axios, $asa }) {
    let seoPhoto = {}
    let storeList
    let storePage
    let galleryPhotoIndex = -1
    let fetchFromStore = false
    switch (query.from) {
      case 'prime':
        storeList = store.state.photos.list
        storePage = store.state.photos.page
        break
      case 'upcoming':
        storeList = store.state.photos.upcomingList
        storePage = store.state.photos.upcomingPage
        break
      case 'opening':
        storeList = store.state.photos.openingList
        storePage = store.state.photos.openingPage
        break
      case 'communityAwarded':
        storeList = store.state.photos.communityAwardedList
        storePage = store.state.photos.communityAwardedPage
        break
      case 'elite':
        storeList = store.state.photos.eliteList
        storePage = store.state.photos.elitePage
        break
      case 'inspiration':
        storeList = store.state.photos.inspirationList
        storePage = store.state.photos.inspirationPage
        break
      case 'curation':
        storeList = store.state.account.list
        storePage = store.state.account.lastFetched
        break
      case 'curated':
        storeList = store.state.account.curated
        storePage = store.state.account.curatedLastFetched
        break
      case 'photographer':
        storeList = store.state.users.photos
        storePage = store.state.users.lastFetched
        break
      case 'uploaded':
        storeList = store.state.account.uploaded
        storePage = store.state.account.uploadedPage
        break
      case 'pending':
        storeList = store.state.account.pending
        storePage = store.state.account.pendingPage
        break
      case 'profile':
        storeList = store.state.account.published
        storePage = store.state.account.publishedPage
        break
      case 'galleries':
        storeList = store.state.galleries.galleryPhotos
        storePage = null
        break
      case 'albums':
        storeList = store.state.albums.albumPhotos
        storePage = null
        break
      default:
        storeList = null
    }

    if (
      [
        'prime',
        'upcoming',
        'opening',
        'communityAwarded',
        'elite',
        'inspiration',
        'curation',
        'curated',
        'photographer',
        'uploaded',
        'pending',
        'profile',
        'galleries',
        'albums'
      ].includes(query.from)
    ) {
      galleryPhotoIndex = findIndex(storeList, p => p.id === parseInt(params.id))
      if (galleryPhotoIndex > -1) {
        seoPhoto = storeList[galleryPhotoIndex]
        fetchFromStore = true
      }
    }

    if (!fetchFromStore) {
      try {
        seoPhoto = await $axios.$get(`/photos/${params.id}`)
      } catch (error) {
        $asa.appInsights('Pages: photo/_id/_slug.vue - method: asyncData', error)
      }
    }

    return {
      seoPhoto,
      storeList,
      storePage,
      galleryPhotoIndex
    }
  },
  data() {
    return {
      types,
      loading: false
    }
  },
  async fetch({ store }) {
    await store.dispatch('photos/resetPhoto')
  },
  head({ $seo }) {
    return $seo({
      title: this.photoTitle,
      description: `Enjoy ${this.seoPhoto.title} by ${this.seoPhoto.photographerName}, one of the best images by 100ASA's community.`,
      url: `https://100asa.com/photo/${this.seoPhoto.id}/${this.seoPhoto.slug}`,
      image: {
        url: this.seoPhoto.thumbnailUrl,
        width: this.seoPhoto.width,
        height: this.seoPhoto.height
      }
    })
  },
  computed: {
    ...mapState({
      me: state => state.auth.user,
      photo: state => state.photos.photo,
      sorround: state => state.photos.sorround,
      info: state => state.photos.info,
      comments: state => state.comments.list,
      isLastPage: state => state.comments.isLastPage,
      page: state => state.comments.page,
      categories: state => state.account.categories,
      featuredIn: state => state.photos.featuredIn
    }),
    photoTitle() {
      let photoTitle = ''
      if (this.seoPhoto.statusName === this.types.photo.status.inCuration) {
        photoTitle = `${this.seoPhoto.title}`
      } else {
        photoTitle = `${this.seoPhoto.title} by ${this.seoPhoto.photographerName}`
      }
      return photoTitle
    }
  },
  async mounted() {
    const params = this.$route.params
    const query = this.$route.query
    const store = this.$store
    const id = params.id

    let photoSetFromStore = false
    let fetchMorePhotos = false

    if (this.galleryPhotoIndex > -1) {
      store.dispatch('photos/setOne', {
        index: this.galleryPhotoIndex,
        from: query.from
      })
      const data = {
        from: query.from,
        prev: this.galleryPhotoIndex === 0 ? null : this.galleryPhotoIndex - 1,
        next:
          this.storeList.length === this.galleryPhotoIndex - 1 ? null : this.galleryPhotoIndex + 1
      }
      store.dispatch('photos/setSorround', data)
      photoSetFromStore = true
      if (this.galleryPhotoIndex === this.storeList.length - 2) {
        fetchMorePhotos = true
      }
    }

    try {
      this.loading = true
      await store.dispatch('account/resetSorround')
      await store.dispatch('photos/getInfo', id)
      await store.dispatch('comments/resetStore')
      if (!photoSetFromStore) {
        await store.dispatch('photos/getOne', {
          id,
          from: query.from
        })
      }
      if (this.seoPhoto.statusName !== this.types.photo.status.inCuration) {
        await store.dispatch('photos/getFeaturedIn', {
          id,
          page: 1,
          size: 10
        })
      }
      if (
        (!store.state.comments.size && query.back !== 'yes') ||
        !store.state.comments.size
      ) {
        await store.dispatch('comments/getPhotoComments', {
          page: 1,
          id
        })
      }
      if (fetchMorePhotos && this.storePage >= 0) {
        await store.dispatch('photos/getPhotos', {
          page: this.storePage + 1,
          status: this.getStatus(query.from),
          awarded: query.from === 'communityAwarded',
          from: query.from
        })
      }
      if (!this.categories || this.categories.length === 0) {
        await store.dispatch('account/getCategories')
      }
    } catch (error) {
      this.$asa.appInsights('Pages: photo/_id/_slug.vue - method: mounted', error)
    } finally {
      this.loading = false
    }

    if (query.trigger === 'notes') {
      EventBus.$emit('open:notes:dialog')
    }

    if (!this.me && this.photo.statusName === types.photo.status.inCuration) {
      EventBus.$emit('snackbar', {
        text: 'You need to log in to view this photo',
        color: 'error'
      })
      this.$router.push('/login')
    }
    EventBus.$on('reloadInfo', id => {
      this.reloadInfo(id)
    })
  },
  methods: {
    getStatus(from) {
      if (from === 'upcoming') {
        return 'upcoming'
      } else if (from === 'opening') {
        return 'opening'
      } else if (from === 'elite') {
        return 'elite'
      } else if (from === 'inspiration') {
        return 'inspiration'
      } else if (from === 'communityAwarded') {
        return false
      } else {
        return 'prime'
      }
    },
    async reloadInfo(id) {
      await this.$store.dispatch('photos/getInfo', id)
    },
    goBack() {
      const q = this.$route.query
      let extraQuery = ''
      let path

      if (q.category) extraQuery += `&category=${q.category}`
      if (q.tags) extraQuery += `&tags=${q.tags}`
      if (q.sort) extraQuery += `&sort=${q.sort}`
      if (q.popularity) extraQuery += `&popularity=${q.popularity}`
      if (q.st) extraQuery += `&st=${q.st}`

      switch (this.$route.query.from) {
        case 'home':
          path = '/'
          break
        case 'uploaded':
        case 'pending':
        case 'profile':
          path = `/account/photos?back=yes&t=${this.$route.query.t || '0'}`
          break
        case 'prime':
          path = `/prime?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'upcoming':
          path = `/upcoming?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'opening':
          path = `/opening?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'communityAwarded':
          path = `/community-awarded?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'elite':
          path = `/elite?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'inspiration':
          path = `/inspiration?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'curation':
          path = `/account/curation?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'curated':
          path = `/account/curated?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'photographer':
        case 'activity':
          path = `/photographer/${this.photo.photographerUserName ||
            this.photo.photographerId}`
          break
        case 'leaderboard':
          path = '/leaderboard'
          break
        case 'feeds':
          path = `/?back=yes&id=${this.$route.params.id}${extraQuery}`
          break
        case 'galleries':
          path = `/galleries/${this.$route.query.gid}?i=0${extraQuery}`
          break
        case 'albums':
          path = `/albums/${this.$route.query.aid}?i=0${extraQuery}`
          break
        case 'manage-albums':
          path = '/account/albums?i=0'
          break
        case 'reviews':
          path = `/community-reviews?st=${q.st}`
          break
        default:
          path = '/prime?back=yes'
          break
      }
      this.$store.dispatch('photos/toggleExpander', false)
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.photo-enter .photo-wrapper,
.photo-leave-active .photo-wrapper {
  transition: opacity 0.45s ease-in-out;
}
.photo-enter .photo-wrapper,
.photo-leave-active .photo-wrapper {
  opacity: 0;
}
</style>
